import * as React from 'react';
import styles from './index.less';
import { Checkbox } from 'antd';
import FCoverImage from '@/components/FCoverImage';
import FComponentsLib from '@freelog/components-lib';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FTooltip from '@/components/FTooltip';
import FIcons from '@/components/FIcons';
import { FI18n } from '@freelog/tools-lib';

interface FResourceCard_AbleCheck_Props {
  checked: boolean;
  disabled?: boolean;
  showUserInfo?: boolean;
  resource: {
    title: string;
    cover: string;
    resourceType: string;
    latestVersion: string;
    policies: string[];
    status: 0 | 1 | 2 | 4;
    updateDate: string;
    username: string;
    useAvatar: string;
    isChoice: boolean;
    authProblem?: boolean;
  };

  onChange?(checked: boolean): void;
}

function FResourceCard_AbleCheck({
  checked,
  disabled = false,
  resource,
  onChange,
  showUserInfo = true,
}: FResourceCard_AbleCheck_Props) {
  return (
    <div style={{ position: 'relative' }}>
      <div
        className={[
          styles.ableCheckCard,
          checked ? styles.checked : '',
          disabled ? styles.disabled : '',
        ].join(' ')}
        onClick={() => {
          if (disabled) {
            return;
          }
          onChange && onChange(!checked);
        }}
      >
        <div>
          <Checkbox checked={checked} disabled={disabled} />
        </div>
        <div style={{ height: 10 }} />
        <FCoverImage src={resource.cover} width={280} />
        <div style={{ height: 10 }} />
        <FComponentsLib.FContentText
          text={resource.title}
          type={'highlight'}
          style={{ maxWidth: 280 }}
          singleRow
        />
        <div style={{ height: 10 }} />
        <div className={styles.ableCheckCardInfo}>
          <FComponentsLib.FContentText
            text={resource.resourceType}
            type={'additional2'}
            style={{ maxWidth: 120 }}
            singleRow
          />

          <div style={{ height: 5 }} />
          <FComponentsLib.FContentText
            singleRow
            type='additional2'
            text={`最新更新时间 ${resource.updateDate}`}
          />
        </div>
        <div style={{ height: 10 }} />
        <div className={styles.MetaFooter}>
          {resource.policies.length > 0 ? (
            <FComponentsLib.F_Contract_And_Policy_Labels
              data={resource.policies.map((p) => {
                return {
                  text: p,
                  dot: '',
                };
              })}
              singleRow
            />
          ) : (
            <FComponentsLib.FContentText text={'暂无策略…'} type='additional2' />
          )}
        </div>
        {showUserInfo && (
          <>
            <div style={{ height: 12 }} />
            <div className={styles.user}>
              <img src={resource.useAvatar || img_choiceLabel} alt={''} />
              <span>{resource.username}</span>
            </div>
          </>
        )}
      </div>

      <div className={styles.Status}>
        <FResourceStatusBadge
          status={
            resource.status === 2
              ? 'freeze'
              : resource.status === 1
              ? 'online'
              : resource.status === 0
              ? 'unreleased'
              : 'offline'
          }
        />
        {resource.authProblem && (
          <FTooltip
            // title={'存在授权问题'}
            title={FI18n.i18nNext.tAuto('alert_resource_no_auth')}
          >
            <FIcons.FWarning style={{ fontSize: 16 }} />
          </FTooltip>
        )}
        {resource.isChoice && (
          <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
            <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
          </FTooltip>
        )}
      </div>
    </div>
  );
}

export default FResourceCard_AbleCheck;
